import {computed, decorate, observable} from 'mobx';
import {faPaperPlane} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';
import i18n from '../i18n/i18n';

export class ReportType extends BaseModel {
  static faIcon = faPaperPlane;

  searchableProperties = ['type', 'url'];
  saveableProperties = ['url', 'additionalHeaders'];

  get typeFormatted() {
    return i18n.t(`reportType.types.${this.type}`);
  }
}

decorate(ReportType, {
  id: observable,
  type: observable,
  url: observable,
  additionalHeaders: observable,
  typeFormatted: computed,
});

/**
 * custom property translations:
 * t('reportType.types.CONSUMPTION')
 * t('reportType.types.INSPECTION_RESULT')
 * t('reportType.types.OPERATION_PERFORMANCE')
 * t('reportType.types.PHASE_PERFORMANCE')
 * t('reportType.types.WORKPLACE_PERFORMANCE')
 * t('reportType.types.YIELD')
 */
export const ReportTypes = Object.freeze({
  PhasePerformance: 'PHASE_PERFORMANCE',
  WorkplacePerformance: 'WORKPLACE_PERFORMANCE',
  OperationPerformance: 'OPERATION_PERFORMANCE',
  Yield: 'YIELD',
  Consumption: 'CONSUMPTION',
  InspectionResult: 'INSPECTION_RESULT',
});
